var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home sb-nav-fixed"},[_c('top-header'),_c('div',{attrs:{"id":"layoutSidenav"}},[_c('main-sidebar'),_c('div',{attrs:{"id":"layoutSidenav_content"}},[_c('main',{attrs:{"id":"main_content"}},[_c('cms-status-banner'),_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }